module.exports = __webpack_public_path__ + "static/media/Publicloginbg.86036e57.mp4";